/**
 * Centralized React Query keys for user data.
 */
export const userQueryKeys = {
  detail: (id: string | undefined) => ["user", id] as const,

  detailPrefix: () => ["user"] as const,

  list: (
    page: number,
    pageSize: number,
    sortBy: string | undefined,
    sortDirection: "asc" | "desc"
  ) => ["users", page, pageSize, sortBy, sortDirection] as const,

  listPrefix: () => ["users"] as const,

  /** Active users, page 1 — impersonation picker (distinct from paginated management list keys). */
  impersonationList: (limit: number) => ["users", "impersonation", 1, limit] as const,

  magicLink: (userId: string) => ["user", userId, "magicLink"] as const,

  /** Placeholder key when magic link query is disabled (no userId). */
  magicLinkDisabled: () => ["user", "magicLink", "disabled"] as const,
};
